import React, { memo, useEffect } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import { Grid, Paper } from "@mui/material";
import Layout from "../../Layout";
import { ApplicationState } from "../../../store";
import { fetchRequest as fetchCert } from "../../../store/cert/actions";
import { Data, caType } from "../../../store/cert/types";
import pageStyles from "../../pageStyles";
import useSession from "../../../effects/useSession";
import PageHeading from "../../../common/pageHeading/PageHeading";
import CertEditForm from "./CertEditForm";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

function CertEdit() {
  const dispatch = useDispatch();
  const classes = pageStyles();

  const { id } = useParams<{ id: string }>();
  const mode = id ? UPDATE : CREATE;

  const certState = useSelector((state: ApplicationState) => state.cert);
  const certList = certState?.data?.data;
  const caMap = certList
    ?.filter((value) => value.attributes?.CA === true)
    .map((c) => {
      return {
        desc: c.attributes.Description,
        serial: c.attributes.SerialNumber,
      };
    }) as caType[];

  const cert = (!isNil(id) ? certList?.find((x) => x.id === id) : null) as Data;
  const session = useSession();

  useEffect(() => {
    dispatch(fetchCert(null));
  }, []);

  const headingText = () => {
    return mode === CREATE ? "New Cert" : "Edit Cert";
  };

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <CertEditForm
                  certificate={cert}
                  caMap={caMap}
                  isCertNew={mode === CREATE}
                />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
export default memo(CertEdit);
